import { useCallback } from 'react'

import { useSegment } from '../../../hooks'

type CampaignOfferEvent =
  | 'Entry Point Viewed'
  | 'Entry Point Clicked'
  | 'Page Viewed'
  | 'Page Dismissed'
  | 'Monthly Plans Viewed'
  | 'Plan Selected'
  | 'Terms Expanded'

export const useTrackBackToSchoolCampaign = () => {
  const { track } = useSegment()

  const trackCampaign = useCallback(
    (event: CampaignOfferEvent, payload?: Record<string, unknown>) => {
      track(`XXX - AG - BTS - Campaign Offer ${event}`, payload)
    },
    [track],
  )

  return { trackCampaign }
}
